import type { HttpPost } from '@/shared/infra/http'
import type { RecordConnectEulaAcceptance } from '@/modules/connect/use-cases'
import { mapConnectError } from './map-connect-error'

export class EdgeRecordConnectEulaAcceptanceRepository {
  constructor(private readonly http: HttpPost) {}

  execute: RecordConnectEulaAcceptance = async (params) => {
    try {
      await this.http.post<{ attested13Plus: true }, unknown>({
        url: '/connect/eula',
        body: { attested13Plus: params.attested13Plus },
      })
    } catch (err) {
      throw mapConnectError(err)
    }
  }
}
